import DOMPurify from 'dompurify';
function sanitizeUrl(r){if(!r)return"about:blank";var t=r.replace(/[ -- -‍﻿]/gim,"").trim();if([".","/"].indexOf(t[0])>-1)return t;var a=t.match(/^([^:]+):/gm);if(!a)return t;var u=a[0];return/^([^w]*)(javascript|data|vbscript)/im.test(u)?"about:blank":t};
if (window.trustedTypes && window.trustedTypes.createPolicy) {
    window.trustedTypes.createPolicy('default', {
        createHTML: (string) => DOMPurify.sanitize(string, {RETURN_TRUSTED_TYPE: true}),
        createScriptURL: string => sanitizeUrl(string),
        createScript: string => string // allow scripts
    });
}